// extracted by mini-css-extract-plugin
export default {"wrapper":"bV-z","availablePromoMessagesLabel":"cV-z","promoMessageList":"dV-z","promoMessage":"eV-z","appliedPromoMessage":"fV-z","promoMessageAmount":"gV-z"};